import React from "react"
import styles from "./FeedCardUsersReacted.module.scss"
import { motion } from "framer-motion"
import type { FeedLike } from "../../../types/feed.ts"

interface FeedCardUsersReactedProps {
  users: FeedLike[]
  handleProfile: (id: number | string, completeName: string) => void
}

const FeedCardUsersReacted: React.FC<FeedCardUsersReactedProps> = ({
  users,
  handleProfile,
}) => {
  return (
    <div className={styles.menu}>
      {Array.isArray(users) &&
        users.map((user, index) => {
          const completeName =
            user.user.type === "COMPANY"
              ? user.user.razon_social ?? ""
              : `${user.user.name ?? ""} ${user.user.last_name ?? ""}`.trim()
          const imageProfile = user.user.image_profile
          const userId = user.user?.id ?? (user as { id?: number }).id
          return (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className={styles.menu_item}
              key={index}
              onClick={() => handleProfile(userId, completeName)}
            >
              <img src={imageProfile} alt="" className={styles.menu_item_img} />
              <p className={styles.menu_item_txt}>{completeName}</p>
            </motion.div>
          )
        })}
    </div>
  )
}

export default FeedCardUsersReacted
